/**
 * check object null atau tidak
 * @param object object untuk di cek
 */
export function isNull ( object: any ) {
    return object == null || typeof object === 'undefined' ; 
}
 
/**
 * glue method, clone object, hanya di level 1 saja. bukan deep clone
 * @param variable variable untuk di clone
 */
export function cloneObject (variable: any  ): any {
    if  ( isNull(variable)) {
        return null ; 
    }
    return Object.assign( {} , variable) ;
}

/**
 * membuat string 0 leaded kalau misal kurang dari 10
 * @param n number untuk di buat zero leaded string
 */
export function makeZeroLeadedString (n: number ): string {
    let s: any = null ; 
    if ( isNull(n)) {
        return s; 
    }
    if ( n <= 9) {
        return '0' + n ; 
    }
    return n + '' ; 
}
/**
 * konversi dari tanggal ke iso date
 * @param date 
 */
export function makeIsoDate (date: Date ): string {
    let s1: any = null ;
    if ( isNull(date)) {
        return s1 ; 
    }
    let s: string = date.getFullYear() + '-' + makeZeroLeadedString( date.getMonth() + 1) + '-' + makeZeroLeadedString(date.getDate()) ; 
    return s ;      
} 



// WEBPACK FOOTER //
// ./src/utils/common-utils.ts